<script>
import Drawer from "@/components/drawer";

// Custom components
import PageHeader from "@/components/page-header";
import intentAddEditDrawer from "@/components/superAdmin/videoBot/intentAddEditDrawer.vue";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Master Intent List",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "Master Intent List",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Master Intent List",
          active: true,
        },
      ],
      addEditIntent: false,
      openNewRequestForm: false,
      isEdit: false,
      isEditable: true,
      tableData: [],
      hotels: [],
      updateValue: "",
      isDataLoading: false,
      is_btn_loading: false,
      hotelId: "",
      hotelName: "",
      avatarImage: "",
      avatarName: "",
      selected: "all",
      isBtnLoading: false,
      sortedbyASC: true,
      injectObj: {
        session_id: "",
        text: "",
        hotel_id: "",
      },
      addLoading: false,
    };
  },
  components: {
    PageHeader,
    Drawer,
    intentAddEditDrawer,
  },
  computed: {
    ...authComputed,
    intentProps() {
      return {
        isEdit: this.isEdit,
        updateValue: this.updateValue,
        isEditable: this.isEditable,
        hotelId: this.hotelId,
        hotelName: this.hotelName,
      };
    },
  },
  mounted() {
    this.getHotelList();
    this.getListOfIntents();
  },
  watch: {
    $route(to, from) {
      this.getListOfIntents();
    },
  },

  methods: {
    getHotelList() {
      UserService.getHotelsList().then((result) => {
        this.hotels = result.results;
      });
    },

    // Get list of all intents
    async getListOfIntents() {
      let tempIntent = [];
      let tempSlot = [];

      this.isDataLoading = true;
      await UserService.getIntentsList().then((response) => {
        tempIntent = response.intentList;
      });
      await UserService.getSlotList().then((response) => {
        tempSlot = response.slotList;
      });

      if (
        this.$route.query.hotel != undefined &&
        this.$route.query.hotel != "all"
      ) {
        this.selected = this.$route.query.hotel;

        await UserService.getVideoChatHotelDetails(
          this.$route.query.hotel
        ).then((result) => {
          this.hotelId = result.hotel_id;
          this.hotelName = result.hotel_name;
          this.avatarImage = result.photo;
          this.avatarName = result.name;

          delete result.hotel_id;
          delete result.hotel_name;

          tempIntent.map((item) => {
            if (result[item.intent_name]) {
              if (
                item.intent_name == result[item.intent_name].name &&
                result[item.intent_name].name != "undefined"
              ) {
                result[item.intent_name].utterances = item.utterances;
                result[item.intent_name].intentId = item.id;
                result[item.intent_name].intent_name = item.intent_name;
                result[item.intent_name].more_status = false;
              }
            }
          });

          tempSlot.map((item) => {
            console.log(result[item.slot_name], "result");
            if (result[item.slot_name]) {
              if (item.slot_name == result[item.slot_name].name) {
                result[item.slot_name].intentId = item.slot_name;
                result[item.slot_name].slot_name = item.slot_name;
              }
            }
          });

          let tempResult = [];
          for (const key in result) {
            tempResult.push(result[key]);
          }

          this.tableData = tempResult;
          this.tableData.sort((x, y) =>
            x["intent_name"] < y["intent_name"] ? -1 : 1
          );
        });
      } else {
        this.hotelName = "";
        this.avatarName = "";
        this.avatarImage = "";

        this.selected = this.$route.query.hotel;
        tempIntent.map((item) => {
          item.more_status = false;
        });

        this.tableData = tempIntent;
        this.tableData.sort((x, y) =>
          x["intent_name"] < y["intent_name"] ? -1 : 1
        );
      }
      this.isDataLoading = false;
    },

    addEditIntentDrawer() {
      if (this.addEditIntent === true) {
        this.isEdit = false;
        this.updateValue = "";
      }
      this.addEditIntent = !this.addEditIntent;
    },

    intentAddedUpdated(data, isEdit, isEditable) {
      if (isEdit && isEditable) {
        this.tableData = this.tableData.map((item) => {
          if (item.intentId === data.intentId) {
            item = data;
          }
          return item;
        });
        this.addUpdateAvatarIntent(data, "edit");
      } else if (isEditable == false) {
        this.addUpdateAvatarIntent(data, "edit");

        this.tableData[data.intent_name].text_reply = data.text_reply;
        this.tableData[data.intent_name].audio_file = data.audio_file;
        this.tableData[data.intent_name].video_file = data.video_file;
      } else {
        this.addUpdateAvatarIntent(data, "add");
        this.tableData.push(data);
      }
      this.addEditIntentDrawer();
    },

    saveAndAddNewIntent(data) {
      this.tableData.push(data);
      this.addEditIntentDrawer();
    },

    editIntent(data, type, index) {
      if (type == false) {
        this.isEditable = false;
      }
      this.isEdit = true;
      this.updateValue = data;
      this.addEditIntentDrawer();
    },

    changeIntenIsCommonStatus(data) {
      UserService.updateIntent(data).then(
        () => {
          Middleware.notification("Successfully changed !!", "success");
        },
        (error) => {
          errorHandler(error);
        }
      );
    },

    hotelSelector() {
      if (this.selected != "") {
        this.$router.push({
          path: "/video-bot",
          query: {
            hotel: this.selected,
          },
        });
      }
    },

    async deployBot() {
      this.isBtnLoading = true;
      await UserService.deployBot()
        .then(() => {
          this.isBtnLoading = false;
          this.createError = true;
        })
        .catch((error) => {
          this.isBtnLoading = false;
          this.createError = true;
          errorHandler(error);

          if (typeof error.response.data.non_field_errors == "object") {
            this.errorMessage = error.response.data.non_field_errors;
          } else {
            this.errorMessage = error.response.data;
          }
        });
    },

    async addUpdateAvatarIntent(data, type) {
      await UserService.getBotAvatarList().then((avatar) => {
        avatar.avatarList.map(async (item) => {
          let tempObj = {};
          tempObj[data.intent_name] = {
            audio_file: "",
            name: data.intent_name,
            id: data.intentId,
            video_file: data.video_file,
            text_reply: data.text_reply,
            is_common: true,
            video_file_duration: data.video_file_duration,
            slot_cmd: data.slot_cmd,
          };

          tempObj = {
            ...tempObj,
            id: item.id,
          };
          await UserService.addUpdateBotAvatarIntent(tempObj).then(
            (response) => {
              console.log(response, "response");
            }
          );
        });
      });
    },

    sortList(sortBy) {
      if (this.sortedbyASC) {
        this.tableData.sort((x, y) => (x[sortBy] > y[sortBy] ? -1 : 1));
        this.sortedbyASC = false;
      } else {
        this.tableData.sort((x, y) => (x[sortBy] < y[sortBy] ? -1 : 1));
        this.sortedbyASC = true;
      }
    },

    InjectTesting(text) {
      this.injectObj.session_id = localStorage.getItem("temp_session_id");
      this.injectObj.text = text;
      this.injectObj.hotel_id = localStorage.getItem("temp_hotel_id");
      this.$refs["inject_testing_modal"].show();
    },

    InjectText() {
      this.addLoading = true;
      localStorage.setItem("temp_session_id", this.injectObj.session_id);
      localStorage.setItem("temp_hotel_id", this.injectObj.hotel_id);

      UserService.injectStream(this.injectObj).then((result) => {
        this.addLoading = false;
        if (result.message == "Injection Failed") {
          Middleware.notification(result.message, "danger");
        } else {
          Middleware.notification(result.message, "success");
        }
      });
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="
        hotelName
          ? '' + hotelName + ' for ' + title + ' - ' + avatarName
          : '' + title + avatarName
      "
      :items="items"
      :action="addEditIntentDrawer"
      text="Add New"
      :isButton="true"
    />

    <div class="row">
      <div class="col-md-3 d-flex align-items-start">
        <select
          class="form-control mb-1"
          v-model="selected"
          @change="hotelSelector()"
        >
          <option value="all">All Hotel Intents</option>
          <option
            v-for="(hotel, index) in hotels"
            :key="hotel + index"
            :value="hotel.id"
          >
            {{ hotel.name }}
          </option>
        </select>
        <img
          v-if="avatarImage"
          :src="'https://vod-lex-files.s3.amazonaws.com/' + avatarImage"
          :alt="avatarName"
          class="avatar-md ms-3"
          style="object-fit: cover"
        />
        <b-button
          v-if="!$route.query.hotel || $route.query.hotel == 'all'"
          class="float-end ms-2 w-50"
          variant="outline-primary"
          type="button"
          :class="{ disabled: isBtnLoading }"
          @click="deployBot"
        >
          <i
            v-if="isBtnLoading"
            class="bx bx-loader bx-spin font-size-16 align-middle me-2"
          ></i>
          Deploy
        </b-button>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="table-responsive">
          <table class="table">
            <thead class="table-light">
              <tr>
                <th @click="sortList('intent_name')">Intent &#8597;</th>
                <th class="w-500">Utterances</th>
                <th class="w-500">Reply</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody v-if="isDataLoading">
              <tr v-for="(item, index) in 10" :key="index">
                <td class="placeholder-glow" v-for="no in 4" :key="no">
                  <span class="placeholder w-100 placeholder-lg"></span>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="(data, index) in tableData" :key="data.id">
                <td @click="openBotDrawer(data.id, index)">
                  {{ data.intent_name }}
                </td>
                <td class="text-wrap w-500 cursor">
                  <p
                    class="mb-0"
                    v-for="(utterances, inx) in data.utterances"
                    :key="inx"
                    @click="InjectTesting(utterances)"
                  >
                    <span v-if="inx == 0 || (inx == 1 && !data.more_status)">
                      <i class="fas fa-arrow-right text-muted me-1 mb-2"></i>
                      {{ utterances }}
                    </span>
                    <span v-if="data.more_status">
                      <i class="fas fa-arrow-right text-muted me-1 mb-2"></i>
                      {{ utterances }}
                    </span>
                  </p>
                  <a
                    @click="data.more_status = !data.more_status"
                    class="text-primary"
                  >
                    {{ data.more_status ? "Less..." : "More..." }}</a
                  >
                </td>
                <td class="text-wrap w-500">
                  <p class="mb-0">
                    {{ data.text_reply }}
                  </p>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <i
                      class="fas fa-microphone-alt fs-5"
                      :class="[
                        data.audio_file == '' ? 'text-muted' : 'text-success',
                      ]"
                    ></i>
                    <i
                      class="fas fa-video fs-5 mx-4 fs-4"
                      :class="[
                        data.video_file == '' ? 'text-muted' : 'text-success',
                      ]"
                    ></i>
                    <i
                      v-if="hotelName == ''"
                      class="fas fa-pencil-alt text-success fs-5"
                      @click="editIntent(data, true)"
                    ></i>

                    <i
                      v-else
                      class="fas fa-pencil-alt text-success fs-5"
                      @click="editIntent(data, false)"
                    ></i>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Drawer -->
    <Drawer
      @close="addEditIntentDrawer"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="addEditIntent">
        <intentAddEditDrawer
          :currentProps="intentProps"
          @submitted="intentAddedUpdated"
          @cancelSubmit="addEditIntentDrawer"
          @saveAndAddNew="saveAndAddNewIntent"
        ></intentAddEditDrawer>
      </div>
    </Drawer>

    <b-modal
      id="modal-"
      size="md"
      ref="inject_testing_modal"
      title="Stream Test"
      title-class="font-18"
      headerClass="justify-content-center"
      centered
      hide-footer
    >
      <div class="card">
        <div class="card-body text-center">
          <form @submit.prevent="InjectText">
            <div class="form-group mb-2">
              <input
                type="text"
                class="form-control"
                v-model="injectObj.session_id"
                placeholder="session id"
                required
              />
            </div>
            <div class="form-group mb-2">
              <input
                type="text"
                class="form-control"
                v-model="injectObj.text"
                placeholder="text"
                required
              />
            </div>
            <div class="form-group mb-2">
              <input
                type="text"
                class="form-control"
                v-model="injectObj.hotel_id"
                placeholder="hotel_id"
                required
              />
            </div>
            <div
              class="spinner-border spinner-border-primary spinner-primary spinner-border-sm"
              role="status"
              v-show="addLoading"
            >
              <span class="sr-only">Loading...</span>
            </div>
            <button class="btn btn-primary" type="submit" v-show="!addLoading">
              Select
            </button>
          </form>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<style scoped>
.w-500 {
  width: 500px;
}
</style>
